import React, { useEffect, useState, useRef } from "react";
import { Button } from "./Button";
import { api, PLATFORM_ROUTE } from "./helpers";
import { Input } from "./Input";
import Toaster from "./Toaster";
import Link from "next/link";

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
        dataLayer: any;
    }
}
export function ForgetPassword() {
    const [email, setEmail] = useState("");
    const [toaster, setToaster] = useState({
        title: <></>,
        description: <></>,
        action: <></>
    });
    const timerRef = useRef(0);
    const [open, setOpen] = useState(false);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        return () => clearTimeout(timerRef.current);
    }, []);


    const handleToast = (title, description: string) => {
        setToaster({
            title: title,
            description: <div>{description}</div>,
            action: <></>
        });
        setOpen(false);
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(() => {
            setOpen(true);
        }, 100);
    };

    const handlePasswordReset = async () => {
        const resp = await api.reset_password_covalent(email);
        if (!resp || resp.error) {
            handleToast(<span className="ToastFail">An error has occured</span>, resp?.error_message ? resp.error_message : "Please try again.");
        } else {
            handleToast(<span className="ToastSuccess">Successfully sent password reset email</span>, "");
            setSuccess(true);
        }
    };

    return <>
        <Toaster title={toaster.title} action={toaster.action} description={toaster.description} open={open} setOpen={setOpen} />
        <div className="reset-container">
            {!success ?
                <>
                    <h2>Enter your email to reset your password</h2>
                    <Input type="email" label="Email" autocomplete="email" placeholder="Enter your email" onChange={(e) => {
                        setEmail(e.target.value);
                    }} />
                    <div className="reset-button">
                        <Button onClick={handlePasswordReset}>Reset Password</Button>
                    </div>
                </>
                :
                <>
                    <h2>Password reset email sent. Please check your email.</h2>
                    <div className="forgot-link">
                        <Link href={`/${PLATFORM_ROUTE}/auth/login/`}>Return to login</Link>
                    </div>
                </>
            }

        </div>
        <style jsx>
            {`
            h2{
                color:var(--pink);
                font-size: var(--font-size-6);
                line-height: var(--line-height-6);

            }
            .re-send{
                color:var(--pink);
            }
            .re-send:hover{
                cursor: pointer;
            }
            .reset-container{
                display:flex;
                flex-direction: column;
                gap:2rem;
                min-width:20rem;
            }
            .reset-button {
                display: block;
                margin-top: 0.25rem;
            }
            .forgot-link {
                display: block;
                margin-top: 0.5rem;
            }
            input {
                padding: .5rem .75rem;
                border-radius: var(--border-radius);
                border: 1px solid lightgrey;
            }
            `}
        </style>
    </>;
}
